import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import CriteriaNumberRangeComponent from '../../components/criteria/CriteriaNumberRangeComponent';
import QRCodeService from '../../services/QRCodeService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';

import Constants from '../../utils/constants';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class QRCodeListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new QRCodeService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
            qrcodeToRemove: null,
        };

        this.service = new QRCodeService();
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            title: criteria.title,
            coinsFrom: criteria.coinsFrom,
            coinsTo: criteria.coinsTo,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            title: '',
            coinsFrom: undefined,
            coinsTo: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'qrcode.listTitle';
    }
    getCriteriaName() {
        return 'qrcode-list-sc';
    }

    getContainerListName() {
        return 'qrcode-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='text-sc'
                        name='title'
                        label={t('qrcode.title')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.title}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaNumberRangeComponent
                        id='text-sc'
                        label={t('qrcode.coins_range')}
                        colClass='col-lg-4 col-sm-6'
                        idFrom='coinsFrom'
                        idTo='coinsTo'
                        nameFrom='coinsFrom'
                        nameTo='coinsTo'
                        from={this.state.criteria.coinsFrom}
                        to={this.state.criteria.coinsTo}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                </div>
            </div>
        );
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('qrcode.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {field: 'status', header: 'Status', sortable: true, width: '90px'},
            {field: 'title', header: t('qrcode.title'), sortable: false},
            {field: 'coinsToEarn', header: t('qrcode.coins'), sortable: true},
            {
                field: 'activeFrom',
                header: t('qrcode.activeFrom'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'activeFrom', Constants.DATE_TIME_FORMAT),
            },
            {
                field: 'activeTo',
                header: t('qrcode.activeTo'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'activeTo', Constants.DATE_TIME_FORMAT),
            },
            {field: 'action', header: t('global.action'), body: this.actionTemplate},
        ];
    }
    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/`+sessionStorage.getItem('i18nextLng');
        return (
            <div>
                <ActionLink
                    rendered={this.backLinkRendered}
                    className='p-link float-right'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
            </div>
        );
    }
    breadCrumbItems() {
        return [{name: t('qrcode.listName'), url: '/qrcode-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

QRCodeListContainer.defaultProps = {
    detailUrl: '/qrcode/details',
    newUrl: '/qrcode/create',
    editUrl: '/qrcode/edit',
    renderChangeLanguegeFilter: true,
    lazy: true,
};

QRCodeListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(QRCodeListContainer));
